export const common = {
  scrollToTop: "العودة إلى الأعلى",
  pagination: {
    totalItems: 'إجمالي العناصر',
    previous: 'السابق',
    next: 'التالي',
    page: 'الصفحة',
    showing: 'عرض',
    to: 'إلى',
    of: 'من',
    items: 'عناصر'
  },
  actions: {
    edit: 'تعديل',
    delete: 'حذف',
    expand: 'توسيع',
    collapse: 'طي',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    close: 'إغلاق',
    print: 'طباعة',
    export: 'تصدير',
    add: 'إضافة',
    title: 'إجراءات'
  },
  status: {
    active: 'نشط',
    inactive: 'غير نشط'
  },
  loading: 'جاري التحميل...',
  noData: 'لا توجد بيانات متاحة',
  filters: {
    sort: {
      label: 'ترتيب حسب',
      placeholder: 'اختر حقل',
      directions: {
        asc: 'تصاعدي',
        desc: 'تنازلي'
      }
    }
  }
}; 